// @flow
import Kolas from './Kolas';
export default Kolas;



// WEBPACK FOOTER //
// ./src/scenes/Kolas/index.js